import { BellIcon } from '@/assets/svg'
import { CheckboxSelect } from '@/components/fragments'
import WrapperCard from '@/components/fragments/wrapper-card'
import { Button } from '@/components/ui/button'
import { useUpdateSettingsMutation } from '@/redux/services/settings'
import { useState, useEffect } from 'react'
import { toast } from 'sonner'

export const getNotificationSettingsFromAPI = (data: any) => {
  if (!data) {
    return {}
  }

  const settingsMap: Record<string, boolean> = {}
  data?.forEach((item: any) => {
    settingsMap[item.key] = item.value
  })

  return settingsMap
}

export const getChangedFields = (settings: any, originalSettings: any) => {
  return Object.keys(settings)
    .filter(
      (key) =>
        settings[key as keyof typeof settings] !==
        originalSettings[key as keyof typeof originalSettings]
    )
    .map((key) => ({
      key,
      value: settings[key as keyof typeof settings],
    }))
}
interface NotificationsProps {
  data: any
  isLoading?: boolean
  isLoadingSettings?: boolean
}

const Notifications = ({ data, isLoadingSettings }: NotificationsProps) => {
  const [settings, setSettings] = useState(
    getNotificationSettingsFromAPI(data?.notification_channels)
  )
  const [originalSettings, setOriginalSettings] = useState(
    getNotificationSettingsFromAPI(data?.notification_channels)
  )
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation()

  useEffect(() => {
    if (data?.notification_channels) {
      const newSettings = getNotificationSettingsFromAPI(
        data?.notification_channels
      )
      setSettings(newSettings)
      setOriginalSettings(newSettings)
    }
  }, [data])

  const handleSettingChange = (key: string, checked: boolean) => {
    setSettings((prev) => ({
      ...prev,
      [key]: checked,
    }))
  }

  const handleSaveChanges = async () => {
    const changedFields = getChangedFields(settings, originalSettings)

    if (changedFields.length === 0) {
      toast.info('No changes to save')
      return
    }
    updateSettings({ settings: changedFields })
      .unwrap()
      .then((response: any) => {
        if (response.success) {
          toast.success(response.message)
        } else {
          toast.error(response.message)
        }
      })
      .catch((error: any) => {
        toast.error(error.data.message)
      })
  }

  const handleReset = () => {
    const resetSettings = getNotificationSettingsFromAPI(data)
    setSettings(resetSettings)
    setOriginalSettings(resetSettings)
  }

  return (
    <div className='space-y-6 mt-4'>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
        <WrapperCard
          title='Notification Channels'
          icon={BellIcon}
          wrapperClassName='h-fit'
          headerClassName='flex flex-row-reverse justify-end items-center gap-2 text-[#424242]'
          loading={isLoadingSettings}
        >
          <div className='space-y-4 mt-4 bg-[#f5f5f5] p-2 md:p-4 rounded-[12px]'>
            <CheckboxSelect
              id='email-notifications'
              label='Email Notifications'
              description='Send notifications via email'
              checked={settings.email_notifications_enabled}
              onChange={(checked) =>
                handleSettingChange('email_notifications_enabled', checked)
              }
              containerClass='rounded-[8px] bg-white p-2.5'
            />

            <CheckboxSelect
              id='sms-notifications'
              label='SMS Notifications'
              description='Send notifications via SMS'
              checked={settings.sms_notifications_enabled}
              onChange={(checked) =>
                handleSettingChange('sms_notifications_enabled', checked)
              }
              containerClass='rounded-[8px] bg-white p-2.5'
            />

            <CheckboxSelect
              id='push-notifications'
              label='Push Notifications'
              description='Send mobile push notifications'
              checked={settings.push_notifications_enabled}
              onChange={(checked) =>
                handleSettingChange('push_notifications_enabled', checked)
              }
              containerClass='rounded-[8px] bg-white p-2.5'
            />
          </div>
        </WrapperCard>

        {/* <WrapperCard
          title='Alert Types'
          icon={AlertIcon}
          wrapperClassName='h-fit'
          headerClassName='flex flex-row-reverse justify-end items-center gap-2 text-[#424242]'
        >
          <div className='space-y-4 mt-4 bg-[#f5f5f5] p-2 md:p-4 rounded-[12px]'>
            <CheckboxSelect
              id='order-updates'
              label='Order Updates'
              description='Notify about order status changes'
              checked={settings.order_updates_enabled}
              onChange={(checked) =>
                handleSettingChange('order_updates_enabled', checked)
              }
              containerClass='rounded-[8px] bg-white p-2.5'
            />
            <CheckboxSelect
              id='payment-alerts'
              label='Payment Alerts'
              description='Notify about payment issues'
              checked={settings.payment_alerts_enabled}
              onChange={(checked) =>
                handleSettingChange('payment_alerts_enabled', checked)
              }
              containerClass='rounded-[8px] bg-white p-2.5'
            />

            <CheckboxSelect
              id='system-maintenance'
              label='System Maintenance'
              description='Notify about system maintenance'
              checked={settings.system_maintenance_enabled}
              onChange={(checked) =>
                handleSettingChange('system_maintenance_enabled', checked)
              }
              containerClass='rounded-[8px] bg-white p-2.5'
            />
          </div>
        </WrapperCard> */}
      </div>

      <div className='flex justify-start space-x-4 pt-4'>
        <Button
          onClick={handleSaveChanges}
          loading={isLoading}
          disabled={isLoading}
          loadingText='Saving...'
          className='w-auto px-6'
        >
          Save Changes
        </Button>
        <Button variant='outline' onClick={handleReset} className='w-auto px-6'>
          Reset
        </Button>
      </div>
    </div>
  )
}

export default Notifications
